/*
 * @Description: 转专业统计
 * @Author: lisenlin
 * @Date: 2021-08-27 00:46:48
 * @LastEditors: lisenlin
 * @LastEditTime: 2021-08-28 16:17:48
 */
import React, { Component } from 'react'
import { Row, Col, Spin } from 'antd'
import { Scrollbars } from 'react-custom-scrollbars';
import getSize from '../../utils/getSize';
import NHFetch from '../../utils/NHFetch';
import { getLoginUser } from '../../utils/NHCore';
import CollegeChangeMajor from './collegeChangeMajor';
import ChangeMajorToal from './changeMajorTotal';
import ChangeMajorByCollege from './changeMajorByCollege';
import StaticTable from './staticTable';
import css from './index.css'

export default class ChangeMajorStatic extends Component {
    constructor(props) {
        super(props);
        this.state = {
            changeMajorList: [],
            importList: [],
            exportList: [],
            xyList: [],
            staticTableXylistData:[],
            changeMajorByCollegeList: [],  //全校各专业转专业情况
        };
    }
    componentDidMount() {
        this.queryChangeMajorList();
        this.queryChangeMajorToal();
        this.queryChangeMajorByCollege();
        this.queryStaticInfo('',false);   //默认查询转入的数据
        this.queryStaticTableXylistData();
    }
    queryChangeMajorList = () => {
        let params = {
            filters: {},
            initParams: {},
            pagination: {},
            searchParams: {},
            searchTextMap: {},
            sign: "zhxg_yxxt_zytz_zr_top",
            sorter: {},
            sqlParams: {}
        }
        NHFetch(baseUrl + "/proData/gridList", "POST", params)
            .then((res) => {
                if (res.data && res.data.list) {
                    this.setState({ importList: res.data.list })
                }
            })
        params.sign = "zhxg_yxxt_zytz_zc_top"
        NHFetch(baseUrl + "/proData/gridList", "POST", params)
            .then((res) => {
                if (res.data && res.data.list) {
                    this.setState({ exportList: res.data.list })
                }
            })
    }
    queryChangeMajorToal = () => {
        const params = {
            filters: {},
            initParams: {},
            pagination: {},
            searchParams: {},
            searchTextMap: {},
            sign: "zhxg_yxxt_zytz_bm",
            sorter: {},
            sqlParams: {}
        }
        NHFetch(baseUrl + "/proData/gridList", "POST", params)
            .then((res) => {
                if (res.data && res.data.list) {
                    this.setState({ changeMajorList: res.data.list })
                }
            })
    }
    queryTableZylistData=(bmid)=>{
        const params = {
            filters: {},
            initParams: {},
            pagination: {},
            searchParams: {},
            searchTextMap: {},
            sign: "zhxg_yxxt_zytz_zy_excel",
            sorter: {},
            sqlParams: {bmid:bmid}
        }
        NHFetch(baseUrl + "/proData/gridList", "POST", params)
            .then((res) => {
                if (res.data && res.data.list) {
                    this.setState({ zyList: res.data.list })
                }
            })
    }
    queryChangeMajorByCollege = () => {
        const params = {
            sign: "zhxg_lxxt_zytz_bm"
        }
        NHFetch(baseUrl + "/proData/selectDataList", "GET", params)
            .then((res) => {
                if (res.data) {
                    let list = [{ LABEL: '全部', VALUE: '' }]
                    list = [...list,...res.data] 
                    this.setState({ xyList: list })
                }
            })
    }
    queryStaticTableXylistData=()=>{
        const params = {
            filters: {},
            initParams: {},
            pagination: {},
            searchParams: {},
            searchTextMap: {},
            sign: "zhxg_yxxt_zytz_bm_excel",
            sorter: {},
            sqlParams: {}
        }
        NHFetch(baseUrl + "/proData/gridList", "POST", params)
            .then((res) => {
                if (res.data && res.data.list) {
                    this.setState({ staticTableXylistData: res.data.list })
                }
            })
    }
    /**
     * 查询全校各专业转专业（转入/转出）数据
     * @param {*} bmid 学院id
     * @param {*} flag true：转出 false：转入
     * @param {*} callback 回调事件
     */
    queryStaticInfo = (bmid,flag, callback) => {
        NHFetch('/yxwz/zzbd/zytzfb/queryStaticInfo','GET',{ bmid, flag })
        .then(res=>{
            if(res&&res.code===200) {
                this.setState({
                    changeMajorByCollegeList: res.data
                },()=>{
                    callback&&callback()
                })
            } else {
                callback&&callback()
            }
        })
    }
    render() {
        const { changeMajorList, importList, exportList, xyList,changeMajorByCollegeList, staticTableXylistData,zyList} = this.state;
        return (
            <div className={css.changeMajorStatic}>
                <Scrollbars
                    autoHeight autoHide autoHeightMax={getSize().windowH - 110}
                >
                    <Row>
                        <Col xs={24} sm={24} md={24} lg={14} xl={14}>
                            <CollegeChangeMajor changeMajorList={changeMajorList} />
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={10} xl={10}>
                            <ChangeMajorToal importList={importList} exportList={exportList} />
                        </Col>
                        <Col span={24} style={{ width: '100%' }}>
                            <ChangeMajorByCollege xyList={xyList} staticList={changeMajorByCollegeList} queryList={this.queryStaticInfo}/>
                        </Col>
                        <Col span={24}>
                            <StaticTable staticTableXylistData={staticTableXylistData} zyList={zyList} queryTableZylistData={this.queryTableZylistData}/>
                        </Col>

                    </Row>
                </Scrollbars>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/changeMajorStaic/index.js